import React, { useState } from "react";
import { IDocumentModel } from "../Common/types";

const useGetSignatureFile = (SignedData: IDocumentModel["SignedData"]) => {
    const blob = new Blob([SignedData], { type: "text/plain" });
    return URL.createObjectURL(blob);
}

export default useGetSignatureFile;